import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/SupervisorSalesBySeller.css';

const SupervisorSalesBySeller = ({ selectedPOS }) => {
  const [salesData, setSalesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7)); // YYYY-MM format

  useEffect(() => {
    fetchSalesBySeller();
  }, [selectedPOS, selectedMonth]);

  const fetchSalesBySeller = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const token = localStorage.getItem('token');
      const params = new URLSearchParams();
      
      if (selectedPOS && selectedPOS !== 'all') {
        params.append('pos_id', selectedPOS);
      }
      
      if (selectedMonth) {
        params.append('month', selectedMonth);
      }

      const response = await axios.get(`/api/supervisors/sales-by-seller?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setSalesData(response.data);
    } catch (error) {
      console.error('Error fetching sales by seller:', error);
      setError('Error al cargar las ventas por vendedor');
    } finally {
      setLoading(false);
    }
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount || 0);
  };

  const getTotalSales = () => {
    return salesData.reduce((total, seller) => total + (seller.total_sales || 0), 0);
  };

  const getTotalTransactions = () => {
    return salesData.reduce((total, seller) => total + (seller.total_transactions || 0), 0);
  };

  if (loading) {
    return (
      <div className="supervisor-sales-by-seller">
        <div className="section-header">
          <h2>Ventas por Vendedor</h2>
        </div>
        <div className="loading-container">
          <p>Cargando ventas por vendedor...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="supervisor-sales-by-seller">
        <div className="section-header">
          <h2>Ventas por Vendedor</h2>
        </div>
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button onClick={fetchSalesBySeller} className="retry-button">
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="supervisor-sales-by-seller">
      <div className="section-header">
        <h2>Ventas por Vendedor</h2>
      </div>

      {salesData.length === 0 ? (
        <div className="no-data-container">
          <p>No hay datos de ventas por vendedor disponibles para el período seleccionado.</p>
        </div>
      ) : (
        <>
          {/* Tabla de ventas por vendedor */}
          <div className="sales-table-container">
            <table className="sales-by-seller-table">
              <thead>
                <tr>
                  <th>Vendedor</th>
                  <th>Punto de Venta</th>
                  <th>Total Ventas</th>
                  <th>Transacciones</th>
                  <th>Ticket Promedio</th>
                  <th>% del Total</th>
                </tr>
              </thead>
              <tbody>
                {salesData.map((seller, index) => {
                  const percentage = ((seller.total_sales || 0) / getTotalSales() * 100).toFixed(1);
                  const averagePerSale = seller.total_transactions > 0 
                    ? (seller.total_sales || 0) / seller.total_transactions 
                    : 0;

                  return (
                    <tr key={seller.seller_id || index}>
                      <td className="seller-name">
                        <div className="seller-info">
                          <span className="name">{seller.seller_name || 'N/A'}</span>
                          <span className="email">{seller.seller_email || ''}</span>
                        </div>
                      </td>
                      <td className="pos-name">{seller.pos_name || 'N/A'}</td>
                      <td className="sales-amount">
                        <span className="amount">{formatCurrency(seller.total_sales)}</span>
                      </td>
                      <td className="transactions-count">
                        <span className="count">{seller.total_transactions || 0}</span>
                      </td>
                      <td className="average-sale">
                        <span className="average">{formatCurrency(averagePerSale)}</span>
                      </td>
                      <td className="percentage">
                        <div className="percentage-container">
                          <span className="percentage-text">{percentage}%</span>
                          <div className="percentage-bar">
                            <div 
                              className="percentage-fill" 
                              style={{ width: `${percentage}%` }}
                            ></div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default SupervisorSalesBySeller;
